import { render, staticRenderFns } from "./PageReportsSummary.vue?vue&type=template&id=1e596c64&"
import script from "./PageReportsSummary.vue?vue&type=script&lang=ts&"
export * from "./PageReportsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./PageReportsSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSpacer,VTab})
